export default __webpack_public_path__ + "static/media/trr-drink-specialty-electric.c3ac44ba.png";